import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseCampaignSearch } from "@/features/growth";
import { CampaignsPage } from "@/features/growth/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/growth/campaigns/")({
  validateSearch: strictSearch(parseCampaignSearch),
  component: Campaigns,
});

function Campaigns() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <CampaignsPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(campaignId) =>
        router.buildLocation({ to: "/growth/campaigns/$campaignId", params: { campaignId } }).href
      }
      onOpen={(campaignId) =>
        void router.navigate({ to: "/growth/campaigns/$campaignId", params: { campaignId } })
      }
    />
  );
}
